<!-- 收货明细 -->
<template>
  <div class="page-content">
    <c-header pageName="待上架列表"></c-header>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :offset="100"
    >
      <div class="goods-item flex-wrap" v-for="(item,index) in orderList" :key="index">
        <section>商品名称 : {{ item.productName }}</section>
        <section>国际编码 : {{ item.barCode }}</section>
        <section>数量 : {{ item.qty }}</section>
        <section>板号 : {{ item.bandSn }}</section>
        <section>批次 : {{ item.batSn }}</section>
        <section>商品状态 :&nbsp;
          <span :style="item.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
            {{ item.defectFlag ? "不良品" : "良品" }}
          </span>
        </section>
        <section>库位 : {{ item.slCode }}</section>
        <section>状态 :&nbsp;
          <span :style="item.status === 0 ? 'color: #F56C6C' : 'color: #67C23A'">
            {{ item.status === 0 ? "待上架" : "已上架" }}
          </span>
        </section>
        <div class="tools" v-if="item.status === 0" @click="handleShelf(item)">
          <section>上架</section>
        </div>
      </div>
    </van-list>
    <c-goodsDetail :show="detailDialogShow" @closeDialog="closeDetailDialog" :info="editInfoDetail"></c-goodsDetail>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import GoodsDetailDialog from "../components/receivingShelveDialog.vue";
import Utils from "../util/utils";
import DataFormat from "../util/dataFormat";

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      loading: false,
      finished: true,
      orderId: "",
      orderSn: "",
      barCode: "",
      orderList: [],
      detailDialogShow: false, // 显示详情弹窗
      editInfoDetail: {}, // 选择进行维护的数据
    };
  },
  components: {
    "c-header": Header,
    "c-goodsDetail": GoodsDetailDialog,
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.getReceivingDetailPage()
  },
  methods: {
    handleShelf(item) {
      this.editInfoDetail = item;
      this.detailDialogShow = true;
    },
    // 获取明细(已收货)
    getReceivingDetailPage() {
      let param = {
        inboundApplyId: this.orderId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        status: 0
      };
      this.$post(this.URL.getReceivingDetailPage, param).then(res => {
        if (res.success) {
          this.orderList = [...this.orderList, ...res.data.records];
          this.finished = res.data.totalPage <= this.currentPage;
          this.loading = false;
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    // 加载更多
    onLoad() {
      if (!this.finished) {
        this.currentPage++;
        this.getReceivingDetailPage();
      }
    },

    closeDetailDialog() {
      this.detailDialogShow = false;
      this.orderList = []
      this.getReceivingDetailPage()
    },
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  width: 100%;
  justify-content: center;
  padding: 0 3rem;
  height: 3rem;
  align-items: center;
  background-color: #dc6350;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }
}

.tool-content {
  font-size: 0.8rem;
  color: #444;
  padding: 0.5rem 0.5rem 0 0.5rem;

  .order-header {
    height: 3rem;
    align-items: center;
    font-size: 0.9rem;
  }

  .button-tool {
    height: 2.5rem;
    align-items: center;
    padding-bottom: 0.5rem;
    border-bottom: 0.2rem solid #f0f0f0;

    label {
      display: inline-flex;
      margin-right: 0.5rem;
      height: 1.8rem;
      align-items: center;
      padding: 0 0.8rem;
      background-color: #dc6350;
      border-radius: 0.2rem;
      color: white;
    }
  }

  .search-tool {
    height: 2.5rem;
    align-items: center;
    border-radius: 0.3rem;
    border: 1px solid #f0f0f0;

    .van-search {
      width: 100%;
      padding: 0;
      //box-shadow: 1px 2px 1px #f0f0f0;
      .van-search__action {
        background-color: white;
      }
    }
  }
}

.search-result {
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  color: #444;
  margin-top: 0.5rem;
  background-color: #fafafa;
  border-radius: 0.3rem;
  margin: 0.5rem;

  .order-left {
    display: inline-flex;
    width: 80%;
    flex-wrap: wrap;

    section {
      display: flex;
      width: 100%;
      padding: 0.2rem 0;
    }
  }

  .order-right {
    display: inline-flex;
    width: 20%;
    align-items: center;
    justify-content: center;

    section {
      display: inline-flex;
      background-color: #dc6350;
      color: white;
      padding: 0.3rem 0.5rem;
      border-radius: 0.2rem;
    }
  }
}

.receiving-button {
  justify-content: center;
  padding-top: 1rem;
  font-size: 0.85rem;

  label {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16rem;
    height: 2.2rem;
    background-color: #dc6350;
    color: white;
    border-radius: 0.2rem;
  }
}

.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;

  .goods-item {
    border-bottom: 1px solid #f0f0f0;
    padding: 0.5rem 0;

    section {
      display: flex;
      width: 100%;
      line-height: 1.2rem;
    }

    .button-tool {
      height: 2.5rem;
      align-items: center;

      label {
        display: inline-flex;
        margin-right: 0.5rem;
        height: 1.8rem;
        align-items: center;
        padding: 0 0.8rem;
        background-color: #dc6350;
        border-radius: 0.2rem;
        color: white;
      }
    }
  }

  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }

}

.van-field__control {
  background-color: white;
}

.van-search .van-cell {
  background-color: white;
}

.van-search__content {
  background-color: white;
}

.van-search__action {
  border-left: 1px solid #f0f0f0;
}

.tools {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 1rem;
  font-size: 0.9rem;

  section {
    display: inline-flex;
    width: 18rem;
    height: 2rem;
    align-items: center;
    justify-content: center;
    background-color: #dc6350;
    border-radius: 0.3rem;
    color: white;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/UnShelvesList.vue